<button class="toggle-btn" (click)="toggle()">
    <mat-icon>{{ open ? 'chevron_right' : 'chevron_left' }}</mat-icon>
</button>
<div class="content" *ngIf="open">
</div>
